export default function AuthorList() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2">
          <span className="text-primary mr-1.5" aria-hidden="true">§</span>
          Authors
        </p>
        <h1 className="font-display text-2xl text-heading [font-variation-settings:'opsz'_96,'SOFT'_60]">
          Author List
        </h1>
      </div>
    </div>
  );
}
